import React from 'react'; // Core React
import { useTranslation } from 'shared/contexts/I18nContext';
// Provides a consistent header structure for content pages.
const ContentHeaderSection = ({ title, subtitle, rightContentTop, rightContentBottom }) => {
    const { t } = useTranslation();
    return (
        <div className="flex flex-col mb-8 gap-2">
            <div className="flex flex-wrap items-center justify-between w-full gap-2">
                <h1 className="text-2xl font-semibold text-gray-900 dark:text-gray-100 tracking-tight leading-tight">{title}</h1>
                {rightContentTop && (
                    <div className="flex-shrink-0 flex items-center gap-2">
                        {rightContentTop}
                    </div>
                )}
            </div>
            <div className="flex flex-wrap items-center justify-between w-full gap-2">
                {subtitle && <p className="text-gray-600 dark:text-gray-400 text-base">{subtitle}</p>}
                {rightContentBottom && (
                    <div className="flex-shrink-0 flex items-center gap-2">
                        {rightContentBottom}
                    </div>
                )}
            </div>
        </div>
    );
};
export default ContentHeaderSection;
